import React, { useContext } from 'react';
import { Subject } from 'rxjs';
import { createHOCWithHookInside } from '../hoc/createHOCWithHookInside';

export const ScrollStreamContext = React.createContext({
  scrollStream: null,
  emitScroll: (_itemId) => {},
});

const scrollStream = new Subject();
const emitScroll = scrollStream.next.bind(scrollStream);

export const ScrollStreamProvider = ({ children }) => (
  <ScrollStreamContext.Provider value={{ scrollStream, emitScroll }}>{children}</ScrollStreamContext.Provider>
);

export const useScrollStream = () => useContext(ScrollStreamContext);

/**
 * @deprecated use "useScrollStream"
 */
export const withScrollStream = createHOCWithHookInside('WithScrollStream', useScrollStream);
